import React, { useEffect, useState } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "./app.css";
import { secretKey } from "./data";
import LoadingPopup from "./loading";

const MySwal = withReactContent(Swal2);

const Conf = (props) => {
  const [loading, setLoading] = useState(true);
  const [sources, setSources] = useState([]);
  const [statuses, setStatuses] = useState([]);

  const fetchLeadSources = async () => {
    var body = {};

    await fetch("https://apisellcrm.ftpeople.pl/getLeadSources", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setSources(data);
        fetchStatuses();
      })
      .catch((error) => {});
  };

  const fetchStatuses = async () => {
    var body = {};

    await fetch("https://apisellcrm.ftpeople.pl/getStatuses", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setStatuses(data);
        setLoading(false);
      })
      .catch((error) => {});
  };

  const getData = () => {
    setLoading(true);
    fetchLeadSources();
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <>
      <div
        style={{
          position: "fixed",
          top: "8vh",
          width: "30vw",
          height: "50vh",
          overflowY: "scroll",
          backgroundColor: "white",
          borderRadius: "15px",
          boxShadow: "8px 8px 24px 0px rgba(66, 68, 90, 1)",
          padding: "1%",
          zIndex: "10",
        }}
      >
        <div style={{ display: "flex", marginBottom: "3vh" }}>
          <div
            style={{
              width: "85%",
              textAlign: "left",
              fontWeight: "600",
              fontSize: "1.5vw",
            }}
          >
            KONFIGURACJA ZAPYTANIA DB
            <br />
          </div>
          <div style={{ width: "15%" }}>
            <button
              className="loginButtonLogin"
              value="yes"
              style={{
                margin: "0",
                backgroundColor: "navy",
                borderColor: "navy",
                width: "100%",
              }}
              onClick={props.close}
            >
              X
            </button>
          </div>
        </div>
        {loading ? (
          <LoadingPopup />
        ) : (
          <>
            <div style={{ textAlign: "left" }}>
              <p style={{ fontWeight: "900" }}>STATUSY</p>
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  alignItems: "center",
                }}
              >
                <div style={{ display: "flex", width: "50%" }}>
                  <div
                    style={{
                      margin: "0",
                      width: "80%",
                      fontSize: ".7vw",
                      fontWeight: "600",
                    }}
                  >
                    Wszystkie
                  </div>
                  <div style={{ margin: "0", width: "20%" }}>
                    <input
                      style={{ width: "15px", height: "15px", margin: "0" }}
                      id={"con1"}
                      className="checkInput"
                      type="checkbox"
                      value={"all"}
                      checked={props.queryStatus === "all" ? true : false}
                      onChange={() => {
                        props.setQueryStatus("all");
                      }}
                    />
                  </div>
                </div>
                {statuses.map((s) => (
                  <>
                    <div style={{ display: "flex", width: "50%" }}>
                      <div
                        style={{ margin: "0", width: "80%", fontSize: ".7vw" }}
                      >
                        {s.name.substring(0, 25) === s.name
                          ? s.name
                          : s.name.substring(0, 25) + "..."}
                      </div>
                      <div style={{ margin: "0", width: "20%" }}>
                        <input
                          style={{ width: "15px", height: "15px", margin: "0" }}
                          id={"con1"}
                          className="checkInput"
                          type="checkbox"
                          value={s.name}
                          checked={
                            props.queryStatus
                              .split(",")
                              .filter((q) => q === s.name).length > 0
                              ? true
                              : false
                          }
                          onChange={() => {
                            var arr = "";
                            if (
                              props.queryStatus
                                .split(",")
                                .filter((q) => q === s.name).length > 0
                            ) {
                              props.queryStatus.split(",").map((p) => {
                                if (p !== s.name) {
                                  arr = arr + "," + p;
                                }
                              });
                            } else {
                              arr = props.queryStatus + "," + s.name;
                            }
                            props.setQueryStatus(arr);
                          }}
                        />
                      </div>
                    </div>
                  </>
                ))}
              </div>
            </div>
            <div style={{ textAlign: "left" }}>
              <p style={{ fontWeight: "900" }}>ŹRÓDŁA</p>
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  alignItems: "center",
                }}
              >
                <div style={{ display: "flex", width: "50%" }}>
                  <div
                    style={{
                      margin: "0",
                      width: "80%",
                      fontSize: ".7vw",
                      fontWeight: "600",
                    }}
                  >
                    Wszystkie
                  </div>
                  <div style={{ margin: "0", width: "20%" }}>
                    <input
                      style={{ width: "15px", height: "15px", margin: "0" }}
                      id={"con1"}
                      className="checkInput"
                      type="checkbox"
                      value={"all"}
                      checked={props.querySource === "all" ? true : false}
                      onChange={() => {
                        props.setQuerySource("all");
                      }}
                    />
                  </div>
                </div>
                {sources.map((s) => (
                  <>
                    <div style={{ display: "flex", width: "50%" }}>
                      <div
                        style={{ margin: "0", width: "80%", fontSize: ".7vw" }}
                      >
                        {s.name.substring(0, 25) === s.name
                          ? s.name
                          : s.name.substring(0, 25) + "..."}
                      </div>
                      <div style={{ margin: "0", width: "20%" }}>
                        <input
                          style={{ width: "15px", height: "15px", margin: "0" }}
                          id={"con1"}
                          className="checkInput"
                          type="checkbox"
                          value={s.name}
                          checked={
                            props.querySource
                              .split(",")
                              .filter((q) => q === s.name).length > 0
                              ? true
                              : false
                          }
                          onChange={() => {
                            var arr = "";
                            if (
                              props.querySource
                                .split(",")
                                .filter((q) => q === s.name).length > 0
                            ) {
                              props.querySource.split(",").map((p) => {
                                if (p !== s.name) {
                                  arr = arr + "," + p;
                                }
                              });
                            } else {
                              arr = props.querySource + "," + s.name;
                            }
                            props.setQuerySource(arr);
                          }}
                        />
                      </div>
                    </div>
                  </>
                ))}
              </div>
            </div>
            <div style={{ textAlign: "left", marginTop: "3vh" }}>
              <button
                className="loginButtonLogin"
                value="yes"
                style={{
                  margin: "0",
                  backgroundColor: "gray",
                  borderColor: "gray",
                  width: "auto",
                  height: "3vh",
                }}
                onClick={() => {
                  props.getData();
                  props.close();
                }}
              >
                ZAPISZ
              </button>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default Conf;
